import { DefaultValues } from "react-hook-form";
import * as yup from "yup";

export const massEmailSchema = yup
  .object({
    userIds: yup
      .array()
      .of(yup.number().required())
      .min(1, "Изберете поне един получател")
      .required("Изберете поне един получател"),
    subject: yup.string().required("Темата е задължителна").defined(),
    body: yup.string().required("Съдържанието е задължително").defined(),
    testEmail: yup
      .string()
      .email("Невалиден имейл адрес")
      .nullable()
      .optional(),
  })
  .required();

export type IMassEmailFormModel = yup.InferType<typeof massEmailSchema>;

export const massEmailFormDefaultValues: DefaultValues<IMassEmailFormModel> = {
  userIds: [],
  subject: "",
  body: "",
  testEmail: "",
};
